<template>
  <b-modal id="fulfillment-save-changes-modal"
    centered
    body-class="text-center">
    <img src="../../assets/images/img-alert.svg" alt="Unsaved Changes" class="img-fluid mb-3">
    <p>You have unsaved changes on this page. Save changes first to proceed.</p>
    <template slot="modal-footer">
      <b-button variant="primary" @click="handleSave">Save Changes</b-button>
      <b-button variant="ghost" class="text-dark" @click="$root.$emit('bv::hide::modal', 'fulfillment-save-changes-modal')">Stay on this page</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "FulfillmentSaveChangesModal",
  props: ["store", "origin"],
  methods: {
    handleSave() {
      this.$root.$emit('handleFulfillmentSave', this.$route.name, this.store);
      this.$root.$emit('bv::hide::modal', 'fulfillment-save-changes-modal');
    }
  }
}
</script>

<style lang="scss">
#fulfillment-save-changes-modal {
  .modal-title {
    display: none;
  }
  .modal-body p {
    color: #49545C;
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
  }
  .modal-footer {
    .btn.btn-ghost {
      color: #68737D;
      font-size: 16px;
      font-family: MainFontBold, sans-serif;
    }
  }
}
</style>
